import UserNotificationsForm from './UserNotificationsForm'

export default UserNotificationsForm
